import angular from 'angular';
import guid from '@/shared/utils/guid';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxCommList', function() {
  return {
    restrict: 'E',
    template: require('./communicationList.html'),
    scope: { field: '=data', title: '@panelTitle', relId: '@', id: '@' },
    controller: [
      '$scope',
      'resourceFactorySvc',
      'objectFactorySvc',
      'flySvc',
      'relBindSvc',
      'openNewAddressSvc',
      '$http',
      '$q',
      '$rootScope',
      '$translate',
      'appUrls',
      'dataCache',
      'translateListFilter',
      function(
        $scope,
        resourceFactorySvc,
        objectFactorySvc,
        flySvc,
        relBindSvc,
        openNewAddressSvc,
        $http,
        $q,
        $rootScope,
        $translate,
        appUrls,
        dataCache,
        translateListFilter,
      ) {
        var resource = resourceFactorySvc.get('commSetting');
        $scope.commList = $scope.field.value;
        $scope.addresses = [];
        $scope.addressCount = [];
        $scope.saving = false;
        $scope.assignmentTemplateOptions = [];
        // labels for every template, also the ones that no longer apply to this relation type,
        // so a stored scope never shows up as "all assignments" just because the picker filtered it out
        $scope.assignmentTemplateLabels = {};
        var assignmentTemplates = [];
        var allAssignmentTemplates = [];

        var toOption = x => ({
          id: x.id,
          code: x.code || '',
          label: `${x.code ? `${x.code} – ` : ''}${translateListFilter(
            x.id,
            'assignmenttemplate',
            x.name,
          )}`,
        });

        var buildAssignmentTemplateOptions = function() {
          var templates = assignmentTemplates
            .map(toOption)
            .sort(dynamicSortMultiple('code', 'label'));
          $scope.assignmentTemplateOptions = [
            { id: guid.empty, label: $translate.instant('DefaultAssignment') },
            { id: 'separator', type: -1 },
            ...templates,
          ];
          $scope.assignmentTemplateLabels = [
            ...$scope.assignmentTemplateOptions,
            ...allAssignmentTemplates.map(toOption),
          ].reduce((result, option) => {
            result[option.id] = option.label;
            return result;
          }, {});
        };

        // only the templates that apply to the relation type can be picked, so reload when the type changes
        var templateRequest = null;
        var loadAssignmentTemplates = function(relationType) {
          if (templateRequest) templateRequest.resolve();
          templateRequest = $q.defer();
          $http
            .get(`${appUrls.api}/api/AssignmentTemplate/Get`, {
              params: { relationType },
              timeout: templateRequest.promise,
              cancel: templateRequest,
            })
            .then(({ data }) => {
              assignmentTemplates = data || [];
              buildAssignmentTemplateOptions();
            });
        };
        var relationType = function() {
          var relation = relBindSvc.relations[$scope.relId];
          return relation ? relation.type : undefined;
        };
        dataCache.ready().then(function() {
          if (!dataCache.getArray('assignmentsEnabled')) return;
          $http.get(`${appUrls.api}/api/AssignmentTemplate/Get`).then(({ data }) => {
            allAssignmentTemplates = data || [];
            buildAssignmentTemplateOptions();
          });
          $scope.$watch(relationType, function(type) {
            if (typeof type === 'undefined') return;
            loadAssignmentTemplates(type);
          });
        });
        var deregisterTranslate = $rootScope.$on(
          '$translateChangeSuccess',
          buildAssignmentTemplateOptions,
        );
        $scope.$on('$destroy', function() {
          if (templateRequest) templateRequest.resolve();
          deregisterTranslate();
        });

        $scope.assignmentTemplateLabel = function(ids) {
          if (!ids || !ids.length) return $translate.instant('AllAssignments');
          return ids.map(id => $scope.assignmentTemplateLabels[id] || id).join(', ');
        };

        var reloadAddresses = function() {
          var fieldId = relBindSvc.relations[$scope.relId].addressesFieldId;
          $scope.addresses = relBindSvc.relations[$scope.relId][fieldId].value;
          $scope.addressCount = $scope.addresses.reduce(
            function(result, address) {
              result[address.medium]++;
              return result;
            },
            [0, 0, 0, 0, 0],
          );
        };
        reloadAddresses();
        $scope.openNewAddress = openNewAddressSvc.openNewAddress;
        openNewAddressSvc.registerCallback($scope, reloadAddresses);

        $scope.newComm = null;

        $scope.addNewComm = function() {
          reloadAddresses();
          // if new comm is null, create a new empty commSetting
          if ($scope.newComm === null) {
            $scope.newComm = objectFactorySvc.commSetting();
            // else set the new comm back to null (= stop adding comm)
          } else $scope.newComm = null;
        };

        $scope.cancelEdit = function(comm) {
          if (comm === $scope.newComm) {
            $scope.newComm = null;
            return;
          }
        };

        $scope.showBillingError = function() {
          var fi = $scope.field.id;
          var relation = relBindSvc.relations[$scope.relId];
          flySvc.message(
            relation[fi].billingError.exception.code,
            relation[fi].billingError.exception.params,
          );
        };

        $scope.getErrorMsg = flySvc.getErrorMsg;

        $scope.newBillingEmailComm = function() {
          reloadAddresses();
          $scope.newComm = objectFactorySvc.commSetting();
          $scope.newComm.purpose = 1;
          $scope.newComm.medium = 1;
        };

        $scope.validate = function(comm) {
          var validate = true;
          comm.error = {};
          if (comm.purpose === null) {
            validate = false;
            comm.error.purpose = true;
          }
          if (comm.medium === null) {
            validate = false;
            comm.error.medium = true;
          }
          if (comm.addressId === '00000000-0000-0000-0000-000000000000' || !comm.addressId) {
            validate = false;
            comm.error.address = true;
          }
          if (
            (comm.error.purpose || comm.error.medium || comm.error.address) &&
            !comm.validationCheckedOnce
          )
            flySvc.error(3029);
          // check if a commSetting with the same purpose, medium an address already exists

          comm.validationCheckedOnce = true;
          return validate;
        };

        $scope.validateAgain = function(comm, fromMedium) {
          if (comm.validationCheckedOnce) $scope.validate(comm);
          //if (fromMedium && comm.error && comm.error.address) comm.error.address=false;
        };

        $scope.saveComm = function(comm, field, value) {
          var model = angular.copy(comm);
          model[field] = value;
          if (!$scope.validate(model)) {
            comm.error = model.error;
            return '';
          }
          if (
            angular.equals(comm[field], value) ||
            comm.id === '00000000-0000-0000-0000-000000000000'
          )
            return false;

          return resource.update(model).$promise.then(
            function(response) {
              comm[field] = value;
              flySvc.success('msgConfirmChange');
              relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);
              return false;
            },
            function(error) {
              flySvc.error(error);
              return '';
            },
          );
        };

        $scope.submitNew = function(comm) {
          if (!$scope.validate(comm)) return;
          if (comm && comm.id === '00000000-0000-0000-0000-000000000000') {
            if (comm.medium !== 1 || comm.purpose === 0) comm.assignmentTemplateIds = [];
            // new commSetting -> save
            $scope.saving = true;
            resource.save(
              comm,
              function(response) {
                $scope.saving = false;
                comm.id = response.setting.id;
                $scope.commList.push(comm);
                $scope.newComm = null;
                flySvc.success('msgCommSaved');
                relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);
              },
              function(error) {
                $scope.saving = false;
                flySvc.error(error);
              },
            );
          }
        };

        $scope.remove = function(comm) {
          comm.removing = true;
          resource.delete(
            { id: comm.id },
            function(response) {
              var index = $scope.commList.indexOf(comm);
              $scope.commList.splice(index, 1);
              flySvc.success('msgCommRemoved');
              relBindSvc.updateRelation($scope.relId, response.changes, response.billingErrors);
            },
            function(error) {
              comm.removing = false;
              flySvc.error(error);
            },
          );
        };
      },
    ],
  };
});
